import React from 'react';
import PropTypes from 'prop-types';

import { SOCIAL_MEDIA_TYPES } from '../../constants';
import SocialIcon, { propTypes as SocialIconPropTypes } from '../SocialIcon';

import './SocialIconRow.scss';

const DEFAULT_ORDER = {
	[SOCIAL_MEDIA_TYPES.EMAIL]: 0,
	[SOCIAL_MEDIA_TYPES.LINKEDIN]: 1,
	[SOCIAL_MEDIA_TYPES.FACEBOOK]: 2,
	[SOCIAL_MEDIA_TYPES.TWITTER]: 3,
	[SOCIAL_MEDIA_TYPES.MESSAGE]: 4,
};

const propTypes = {

	/**
	 * The icons to display in this row.
	 */
	icons: PropTypes.arrayOf(
		PropTypes.shape({
			...SocialIconPropTypes,

			// SocialIcon defaults this, so an icon may leave it out —
			// the "message" icon is only ever built for another user
			isSelf: PropTypes.bool,
		})
	).isRequired,

};

/**
 * Shared component to render a basic TechChange-style row of social media icons.
 *
 * @param {Object} props The props.
 * @returns {Object} The rendered component.
 */
const SocialIconRow = ({ icons }) => {

	const sortedIcons =
		icons &&
		icons.sort((icon1, icon2) => DEFAULT_ORDER[icon1.type] - DEFAULT_ORDER[icon2.type]);

	return (
		<div className="tc-social-icon-row">
			{sortedIcons && sortedIcons.map((icon) => (
				<SocialIcon
					key={icon.type}
					{...icon} />
			))}
		</div>
	);

};

SocialIconRow.propTypes = propTypes;

export default SocialIconRow;
